(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padeluxe-custom-collections-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('[data-pc-quick-add]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var variantId = btn.getAttribute('data-variant-id');
        if (!variantId) return;
        var originalText = btn.innerHTML;
        btn.disabled = true;
        btn.innerHTML = 'Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.innerHTML = 'Added ✓';
          // Trigger Shopify's cart drawer update if available
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (window.Shopify && window.Shopify.onCartUpdate) { window.Shopify.onCartUpdate(); }
          setTimeout(function() {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 1800);
        })
        .catch(function() {
          btn.innerHTML = 'Try again';
          setTimeout(function() {
            btn.innerHTML = originalText;
            btn.disabled = false;
          }, 1800);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["padeluxe-product-page"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.padel-product').forEach(function(root) {
      var sectionId = root.id.replace('padel-product-', '');
      var mainImg = root.querySelector('#pp-active-img-' + sectionId);
      var thumbs = root.querySelectorAll('[data-pp-thumb]');
      var select = root.querySelector('#pp-variant-select-' + sectionId);
      var qtyInput = root.querySelector('#pp-qty-' + sectionId);
      var addBtn = root.querySelector('#pp-add-' + sectionId);
      var addPriceEl = root.querySelector('#pp-add-price-' + sectionId);
      var priceNow = root.querySelector('.pp-price-now');
      var priceWas = root.querySelector('.pp-price-was');

      // THUMBS
      thumbs.forEach(function(thumb) {
        thumb.addEventListener('click', function() {
          if (!mainImg) return;
          mainImg.style.opacity = '0';
          setTimeout(function() {
            mainImg.src = thumb.getAttribute('data-image-url');
            mainImg.style.opacity = '1';
          }, 150);
          thumbs.forEach(function(t) { t.classList.remove('pp-thumb-active'); });
          thumb.classList.add('pp-thumb-active');
        });
      });

      // QTY
      root.querySelectorAll('[data-pp-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          if (!qtyInput) return;
          var current = parseInt(qtyInput.value, 10) || 1;
          if (btn.getAttribute('data-pp-qty') === '+') {
            qtyInput.value = current + 1;
          } else if (current > 1) {
            qtyInput.value = current - 1;
          }
        });
      });

      // VARIANT OPTIONS — update active pills + matching variant
      var optionInputs = root.querySelectorAll('[data-pp-option]');
      optionInputs.forEach(function(input) {
        input.addEventListener('change', function() {
          var position = input.getAttribute('data-option-position');
          // Update pill active state for this option group
          root.querySelectorAll('[data-pp-option][data-option-position="' + position + '"]').forEach(function(other) {
            other.closest('.pp-option-pill').classList.remove('pp-option-pill-active');
          });
          input.closest('.pp-option-pill').classList.add('pp-option-pill-active');
          // Update displayed value label
          var valueLabel = root.querySelector('[data-pp-selected-value="' + position + '"]');
          if (valueLabel) valueLabel.textContent = input.value;

          // Find the matching variant
          var selectedOptions = [];
          var optionGroups = root.querySelectorAll('.pp-option');
          optionGroups.forEach(function(group, i) {
            var checked = group.querySelector('input[type="radio"]:checked');
            if (checked) selectedOptions[i] = checked.value;
          });

          if (select) {
            for (var i = 0; i < select.options.length; i++) {
              var opt = select.options[i];
              var variantOpts = opt.getAttribute('data-options').split('|');
              var match = selectedOptions.every(function(val, idx) { return variantOpts[idx] === val; });
              if (match) {
                select.selectedIndex = i;
                // Update prices and button
                if (priceNow) priceNow.textContent = opt.getAttribute('data-price');
                if (addPriceEl) addPriceEl.textContent = opt.getAttribute('data-price');
                var comparePrice = opt.getAttribute('data-compare-price');
                if (priceWas && comparePrice && comparePrice !== '$0.00') {
                  priceWas.textContent = comparePrice;
                  priceWas.style.display = '';
                } else if (priceWas) {
                  priceWas.style.display = 'none';
                }
                if (addBtn) {
                  var available = opt.getAttribute('data-available') === 'true';
                  addBtn.disabled = !available;
                  var addText = addBtn.querySelector('.pp-add-text');
                  if (addText) addText.textContent = available ? 'Add to cart' : 'Sold out';
                }
                break;
              }
            }
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
